import React from 'react';

import { useTheme } from '@mui/material/styles';

function LogoIcon() {
    const theme = useTheme();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={56} height={56} fill="none">
            <rect fill={theme.palette.background.tableSecondary} width={56} height={56} rx={12} className="transition" />
            <path fill="#105C72" d="m31.584 20.362 10.09.503-16.61.11L14 20.489l17.584-.126Z" />
            <path fill="#197A92" d="M31.584 15v5.363L14 20.488v-5.275L31.584 15Z" />
            <path fill="#40B2E0" d="m31.585 15 10.09.852v5.013l-10.09-.502V15Z" />
            <path fill="#197A92" d="M31.584 35.815v5.363L14 40.965V35.69l17.584.125Z" />
            <path fill="#40B2E0" d="m31.585 35.816 10.09-.503v5.014l-10.09.851v-5.362Z" />
            <path fill="#105C72" d="m14 35.69 11.064-.488 16.612.11-10.09.503L14 35.69Z" />
            <path fill="#197A92" d="M31.584 25.409v5.362L14 30.727v-5.275l17.584-.043Z" />
            <path fill="#40B2E0" d="m31.585 25.409 10.09.174v5.013l-10.09.174V25.41Z" />
        </svg>
    );
}

export default LogoIcon;
